import React, { useEffect } from 'react';
import donorFavicon from "../../assets/Donor.svg";
import defaultFavicon from '../../assets/favicon.svg';

const DynamicFavicon = ({ isDonationMode }) => {
  useEffect(() => {
    const favicon = document.querySelector("link[rel='icon']");
    const appleTouchIcon = document.querySelector("link[rel='apple-touch-icon']");
    
    if (favicon) {
      favicon.href = isDonationMode ? donorFavicon : defaultFavicon;
    }
    
    if (appleTouchIcon) {
      appleTouchIcon.href = isDonationMode ? donorFavicon : defaultFavicon;
    }
  }, [isDonationMode]);

  return null;
};

export default DynamicFavicon; 